<ng-container *ngIf="observations_historique.length > 0">
  <mat-accordion>
    <mat-expansion-panel class="history-pan">
      <mat-expansion-panel-header>
        <mat-panel-title> <mat-icon>history</mat-icon> {{title}} </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="history-pan--content" *ngFor="let content of observations_historique">
        <span class="history-pan--content-line">Le {{content.dt_created | date:'dd/MM/yyyy à HH:mm' }}</span>
        <span class="history-pan--content-line-mr" [innerHTML]="content.commentaire | newline"></span>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</ng-container>

